import React, { useMemo } from 'react';
import { Progress } from 'tea-component';
import { DBO_V } from '@op/utils/format';
import { newsDataSourceColorMap, newsDataSourceIconMap } from '@op/constants/news';
import './index.scss';

export default function DataSourceList(props: { dataSourceList: { [key: string]: number; }; total: number; defaultDataSourceList: string[]; }) {
  const { dataSourceList, total, defaultDataSourceList } = props;

  const realDataSourceList = useMemo(() => {
    const defaultSourceList = defaultDataSourceList.reduce<Record<string, number>>((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});
    return {
      ...defaultSourceList,
      ...(dataSourceList ?? {})
    };
  }, [dataSourceList, defaultDataSourceList]);

  const SourceBar = (props: { name: string; value: number; }) => {
    const { name, value } = props;
    const color = useMemo(() => newsDataSourceColorMap?.[name] || undefined, [name]);
    const icon = useMemo(() => newsDataSourceIconMap?.[name] || '', [name]);
    return (
      <>
        <div className='data-source-wrapper'>
          <div className='data-source-details'>
            {
              icon && (
                <img src={icon} className='data-source-icon' />
              )
            }
            <span className='data-source-name'>{name}</span>
          </div>
          <span className='data-source-value'>{DBO_V.percentage(value, total, 2)}</span>
        </div>
        <Progress percent={DBO_V.percentageValue(value, total) * 100} strokeColor={color} />
      </>
    );
  };

  return (
    <div className='dbo-news-data-source-list'>
      {
        Object.entries(realDataSourceList).map(([key, value]: [string, number]) => (
          <SourceBar
            key={key}
            name={key}
            value={value}
          />
        ))
      }
    </div>
  );
}